"use client";
import React, { useState } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";

import { toast, Bounce } from "react-toastify";

const StopLiveStreamConfirm = ({ data }) => {
	const { fetchPostData, error } = useFetchPost();
	const handleClose = () => {
		const confirmModal = document.getElementById("stopLiveStreamConfirmModal");
		confirmModal.classList.remove("show");
		confirmModal.style.display = "none";
	};
	// Function to handle data submission
	const handleSubmit = async () => {
		// Process the data or perform any actions
		const postData = {
			//product_key: data && data.product_key,
			user_uuid: data && data.user_uuid,
			livestream_uuid: data && data.livestream_uuid,
			key: data && data.type,
			server: data && data.server,
			app_token: data && data.app_token,
		};
		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi6/stop-livestream-info";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}

		if (responseData && responseData.code == 200) {
			toast.success(responseData.message, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";

			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			// Action to take if user clicks "Cancel" or closes the dialog
			console.warn("Something went wrong to fetching data for auto login.");
		}

		// Close the modal
		const confirmModal = document.getElementById("stopLiveStreamConfirmModal");
		confirmModal.classList.remove("show");
		confirmModal.style.display = "none";
	};

	return (
		<div
			className="modal fade"
			id="stopLiveStreamConfirmModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="stopLiveStreamConfirmModalLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4
							className="modal-title"
							id="stopLiveStreamConfirmModalLabel"
							style={{ color: "rgb(87, 87, 87)" }}
						>
							Login To Account
						</h4>
					</div>
					<div className="modal-body">
						<h5 style={{ color: "rgb(87, 87, 87)" }}>{data && data.confirmText}</h5>
					</div>
					<div className="modal-footer">
						<a type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</a>
						<a type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StopLiveStreamConfirm;



// WEBPACK FOOTER //
// ./src/components/crm/modals/StopLiveStreamConfirm.jsx